export { default } from './TrophyCheck'
